import { render, staticRenderFns } from "./BookingPage.vue?vue&type=template&id=35dc5d67&scoped=true"
import script from "./BookingPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./BookingPage.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./BookingPage.vue?vue&type=style&index=0&id=35dc5d67&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35dc5d67",
  null
  
)

export default component.exports